// source: pushwoosh/email_templates/email_templates.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.EmailContent', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.EmailContent.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.EmailTemplate', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderBy', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderDirection', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.EmailTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.EmailTemplate.displayName = 'proto.pushwoosh.rpc_v2.accounts.EmailTemplate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.rpc_v2.accounts.EmailContent.oneofGroups_);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.EmailContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.EmailContent.displayName = 'proto.pushwoosh.rpc_v2.accounts.EmailContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.displayName = 'proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.displayName = 'proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.displayName = 'proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.displayName = 'proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.displayName = 'proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    content: (f = msg.getContent()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.toObject(includeInstance, f),
    label: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest;
  return proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.serializeBinaryToWriter
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional EmailContent content = 3;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.getContent = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent, 3));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.hasContent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string label = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateRequest.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailTemplate: (f = msg.getEmailTemplate()) && proto.pushwoosh.rpc_v2.accounts.EmailTemplate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse;
  return proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailTemplate;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailTemplate.deserializeBinaryFromReader);
      msg.setEmailTemplate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailTemplate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * optional EmailTemplate email_template = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailTemplate}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.prototype.getEmailTemplate = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailTemplate} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailTemplate, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailTemplate|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.prototype.setEmailTemplate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.prototype.clearEmailTemplate = function() {
  return this.setEmailTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateEmailTemplateResponse.prototype.hasEmailTemplate = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.EmailTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    content: (f = msg.getContent()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.toObject(includeInstance, f),
    label: jspb.Message.getFieldWithDefault(msg, 3, ""),
    code: jspb.Message.getFieldWithDefault(msg, 4, ""),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.EmailTemplate;
  return proto.pushwoosh.rpc_v2.accounts.EmailTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.EmailTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.serializeBinaryToWriter
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional EmailContent content = 2;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.getContent = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent, 2));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.hasContent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string code = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp created = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp updated = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailTemplate.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    content: (f = msg.getContent()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.toObject(includeInstance, f),
    label: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest;
  return proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.serializeBinaryToWriter
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional EmailContent content = 3;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.getContent = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent, 3));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.hasContent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string label = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateRequest.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailTemplate: (f = msg.getEmailTemplate()) && proto.pushwoosh.rpc_v2.accounts.EmailTemplate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse;
  return proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailTemplate;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailTemplate.deserializeBinaryFromReader);
      msg.setEmailTemplate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailTemplate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * optional EmailTemplate email_template = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailTemplate}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.prototype.getEmailTemplate = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailTemplate} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailTemplate, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailTemplate|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.prototype.setEmailTemplate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.prototype.clearEmailTemplate = function() {
  return this.setEmailTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.CreateEmailTemplateResponse.prototype.hasEmailTemplate = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.oneofGroups_ = [[3,4,5]];

/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.KindCase = {
  KIND_NOT_SET: 0,
  UNLAYER: 3,
  PUSHWOOSH: 4,
  RAW: 5
};

/**
 * @return {proto.pushwoosh.rpc_v2.accounts.EmailContent.KindCase}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.rpc_v2.accounts.EmailContent.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.rpc_v2.accounts.EmailContent.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.toObject = function(includeInstance, msg) {
  var f, obj = {
    senderInfo: (f = msg.getSenderInfo()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.toObject(includeInstance, f),
    subjectMap: (f = msg.getSubjectMap()) ? f.toObject(includeInstance, undefined) : [],
    unlayer: (f = msg.getUnlayer()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.toObject(includeInstance, f),
    pushwoosh: (f = msg.getPushwoosh()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.toObject(includeInstance, f),
    raw: (f = msg.getRaw()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.EmailContent;
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.deserializeBinaryFromReader);
      msg.setSenderInfo(value);
      break;
    case 2:
      var value = msg.getSubjectMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 3:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.deserializeBinaryFromReader);
      msg.setUnlayer(value);
      break;
    case 4:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.deserializeBinaryFromReader);
      msg.setPushwoosh(value);
      break;
    case 5:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.deserializeBinaryFromReader);
      msg.setRaw(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.EmailContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSenderInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.serializeBinaryToWriter
    );
  }
  f = message.getSubjectMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getUnlayer();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.serializeBinaryToWriter
    );
  }
  f = message.getPushwoosh();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.serializeBinaryToWriter
    );
  }
  f = message.getRaw();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: (f = msg.getFrom()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.toObject(includeInstance, f),
    replyTo: (f = msg.getReplyTo()) && proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo;
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 3:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.deserializeBinaryFromReader);
      msg.setReplyTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.serializeBinaryToWriter
    );
  }
  f = message.getReplyTo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address;
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Address from = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.getFrom = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Address reply_to = 3;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.getReplyTo = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address, 3));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.Address|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.setReplyTo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.clearReplyTo = function() {
  return this.setReplyTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo.prototype.hasReplyTo = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.toObject = function(includeInstance, msg) {
  var f, obj = {
    html: jspb.Message.getFieldWithDefault(msg, 1, ""),
    localizationData: (f = msg.getLocalizationData()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    editorConfig: (f = msg.getEditorConfig()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer;
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtml(value);
      break;
    case 2:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setLocalizationData(value);
      break;
    case 3:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setEditorConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocalizationData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getEditorConfig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
};


/**
 * optional string html = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.getHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.setHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Struct localization_data = 2;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.getLocalizationData = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 2));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.setLocalizationData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.clearLocalizationData = function() {
  return this.setLocalizationData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.hasLocalizationData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Struct editor_config = 3;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.getEditorConfig = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 3));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.setEditorConfig = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.clearEditorConfig = function() {
  return this.setEditorConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer.prototype.hasEditorConfig = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.toObject = function(includeInstance, msg) {
  var f, obj = {
    html: jspb.Message.getFieldWithDefault(msg, 1, ""),
    localizationData: (f = msg.getLocalizationData()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh;
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtml(value);
      break;
    case 2:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setLocalizationData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHtml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocalizationData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
};


/**
 * optional string html = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.prototype.getHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.prototype.setHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Struct localization_data = 2;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.prototype.getLocalizationData = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 2));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.prototype.setLocalizationData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.prototype.clearLocalizationData = function() {
  return this.setLocalizationData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh.prototype.hasLocalizationData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.toObject = function(includeInstance, msg) {
  var f, obj = {
    htmlMap: (f = msg.getHtmlMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw;
  return proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getHtmlMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHtmlMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * map<string, string> html = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.prototype.getHtmlMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw.prototype.clearHtmlMap = function() {
  this.getHtmlMap().clear();
  return this;};


/**
 * optional SenderInfo sender_info = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.getSenderInfo = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent.SenderInfo|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.setSenderInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.clearSenderInfo = function() {
  return this.setSenderInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.hasSenderInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, string> subject = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.getSubjectMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.clearSubjectMap = function() {
  this.getSubjectMap().clear();
  return this;};


/**
 * optional Unlayer unlayer = 3;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.getUnlayer = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer, 3));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent.Unlayer|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.setUnlayer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.rpc_v2.accounts.EmailContent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.clearUnlayer = function() {
  return this.setUnlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.hasUnlayer = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Pushwoosh pushwoosh = 4;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.getPushwoosh = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh, 4));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent.Pushwoosh|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.setPushwoosh = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.rpc_v2.accounts.EmailContent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.clearPushwoosh = function() {
  return this.setPushwoosh(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.hasPushwoosh = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Raw raw = 5;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.getRaw = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw, 5));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailContent.Raw|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
*/
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.setRaw = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.rpc_v2.accounts.EmailContent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailContent} returns this
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.clearRaw = function() {
  return this.setRaw(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.EmailContent.prototype.hasRaw = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string code = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailTemplate: (f = msg.getEmailTemplate()) && proto.pushwoosh.rpc_v2.accounts.EmailTemplate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailTemplate;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailTemplate.deserializeBinaryFromReader);
      msg.setEmailTemplate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailTemplate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * optional EmailTemplate email_template = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.EmailTemplate}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.prototype.getEmailTemplate = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.EmailTemplate} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailTemplate, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.EmailTemplate|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.prototype.setEmailTemplate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.prototype.clearEmailTemplate = function() {
  return this.setEmailTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateResponse.prototype.hasEmailTemplate = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderDirection: jspb.Message.getFieldWithDefault(msg, 3, 0),
    page: jspb.Message.getFieldWithDefault(msg, 4, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 5, 0),
    searchByName: (f = msg.getSearchByName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    searchByLabel: (f = msg.getSearchByLabel()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    strictSearchByLabel: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest;
  return proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 2:
      var value = /** @type {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderBy} */ (reader.readEnum());
      msg.setOrderBy(value);
      break;
    case 3:
      var value = /** @type {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderDirection} */ (reader.readEnum());
      msg.setOrderDirection(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearchByName(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearchByLabel(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStrictSearchByLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderBy();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOrderDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSearchByName();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSearchByLabel();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictSearchByLabel();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderBy = {
  NAME: 0,
  CREATED: 1,
  UPDATED: 2
};

/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderDirection = {
  ASC: 0,
  DESC: 1
};

/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OrderBy order_by = 2;
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderBy}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.getOrderBy = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderBy} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderBy} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional OrderDirection order_direction = 3;
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderDirection}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.getOrderDirection = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderDirection} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.OrderDirection} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.setOrderDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 page = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 per_page = 5;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue search_by_name = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.getSearchByName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.setSearchByName = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.clearSearchByName = function() {
  return this.setSearchByName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.hasSearchByName = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue search_by_label = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.getSearchByLabel = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.setSearchByLabel = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.clearSearchByLabel = function() {
  return this.setSearchByLabel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.hasSearchByLabel = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool strict_search_by_label = 8;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.getStrictSearchByLabel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesRequest.prototype.setStrictSearchByLabel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailTemplatesList: jspb.Message.toObjectList(msg.getEmailTemplatesList(),
    proto.pushwoosh.rpc_v2.accounts.EmailTemplate.toObject, includeInstance),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 3, 0),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse;
  return proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.EmailTemplate;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.EmailTemplate.deserializeBinaryFromReader);
      msg.addEmailTemplates(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailTemplatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.EmailTemplate.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated EmailTemplate email_templates = 1;
 * @return {!Array<!proto.pushwoosh.rpc_v2.accounts.EmailTemplate>}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.getEmailTemplatesList = function() {
  return /** @type{!Array<!proto.pushwoosh.rpc_v2.accounts.EmailTemplate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.rpc_v2.accounts.EmailTemplate, 1));
};


/**
 * @param {!Array<!proto.pushwoosh.rpc_v2.accounts.EmailTemplate>} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.setEmailTemplatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.accounts.EmailTemplate}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.addEmailTemplates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pushwoosh.rpc_v2.accounts.EmailTemplate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.clearEmailTemplatesList = function() {
  return this.setEmailTemplatesList([]);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 per_page = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.ListEmailTemplatesResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest;
  return proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse;
  return proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.DeleteEmailTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsRequest.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    labelsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string labels = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.prototype.getLabelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.prototype.setLabelsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.prototype.addLabels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailTemplateLabelsResponse.prototype.clearLabelsList = function() {
  return this.setLabelsList([]);
};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.accounts);
